<template>
  <div>
    <div class="page case-detail__content">
      <div class="panel">
        <div class="panel-header">
          <el-form size="small" label-width="100px" class="margin15-tb">
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="公司">
                  <el-select v-model="company.companySelected" filterable placeholder="请选择" style="width: 100%;" @change="companyChange">
                    <el-option v-for="item in company.companyOption" :key="item.id" :label="item.companyName" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="策略组">
                  <el-select v-model="group.groupSelected" filterable placeholder="请选择" style="width: 80%;" @change="groupChange">
                    <el-option
                      v-for="item in group.groupOption"
                      :key="item.id"
                      :label="item.groupName"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="场景">
                  <el-select v-model="sceneSelected" filterable placeholder="请选择" style="width: 80%;">
                    <el-option
                      v-for="item in sceneOption"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="17">
                <div class="text right">
                  <el-button type="primary" size="small" @click="initSimulate('initSession')" v-show="initButton" plain>初始对话</el-button>
                  <el-button type="primary" size="small" @click="initSimulate('resetSession')" v-show="resetButton" plain>重置对话</el-button>
                  <!-- <el-button type="primary" size="small" @click="nextStrategy" plain>触发下个回复</el-button> -->
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="panel-content">
          <!-- 聊天框 -->
          <div class="chat-wrapper">
            <div class="chat-header"><i class="fa fa-comments"></i> 和{{chatName}}的聊天</div>
            <div class="chat-content" style="overflow:scroll;" ref="chat_content">
              <div class="msg-box padding15">
                <!-- 聊天框内容渲染 -->
                <template v-for="(item, index)  of chatList">
                  <!-- 对方 -->
                  <div v-if="item.type === 'response'" class="align-left" :key="generator('chat',index)">
                    <div class="item">
                      <div class="label">
                        <img class="avatar" src="/static/imgs/default_avatar.png">
                      </div>
                      <div class="content">
                        <div>
                          <div class="message">{{item.content}}</div>
                          <p class="time">
                            <span><el-tag type="info" size="mini" :hit="false">{{item.sendWay === 'msg' ? '短信' : item.sendWay === 'svoice' ? '场景语音' : '语音'}}</el-tag></span>
                            <span>{{item.time}}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 自己 -->
                  <div v-else class="align-right" :key="generator('chat',index)">
                    <div class="item">
                      <div class="content">
                        <div>
                          <div class="message">{{item.content}}</div>
                          <p class="time">
                            <span><el-tag type="info" size="mini" color="#f7f7f7" :hit="false">{{item.label}}</el-tag></span>
                            &nbsp;<span><el-tag type="success" size="mini" color="#f7f7f7" :hit="false">{{ item.field }}: {{ item.emoji }}</el-tag></span>
                            <span name='responseTime'>{{item.time}}</span>
                          </p>
                        </div>
                      </div>
                      <div class="label">
                        <img class="avatar" src="/static/imgs/default_avatar.png">
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div class="chat-footer" v-if="this.$hasPerm('XQ010')">
              <el-row :gutter="10">
                <el-col :span="19">
                  <el-input
                    type="text"
                    size="small"
                    placeholder="请输入内容"
                    v-model="selectTemplate.finalTemplate" @keyup.enter.native="sendMsg">
                  </el-input>
                </el-col>
                <el-col :span="3">
                  <el-button type="primary" size="small" style="width: 100%;" @click="sendMsg()">发送</el-button>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';

export default {
  data() {
    return {
      field: '',
      emojiMap: {
        '喜好': '😊',
        '悲伤': '😭',
        '厌恶': '😒',
        '高兴': '😄',
        '愤怒': '😡',
        '抱怨': '😮‍💨',
        '恐惧': '😱',
        '惊讶': '😨',
        '认可': '👍🏻',
        '投诉': '🤬',
        '感谢': '🌹'
      },
      statusList: [],
      comboxCaseOption: [
        {
          value: '0',
          label: '否'
        },
        {
          value: '1',
          label: '是'
        }
      ],
      chatList: [],
      selectTemplate: {
        finalTemplate: ''
      },
      simulateStatusUpdateReq: {
        caseStatus: '',
        contactStatus: '',
        mobileStatus: '',
        comboxCase: ''
      },
      groupReq: {
        companyId: ''
      },
      company: {
        companySelected: '',
        companyOption: [],
        strategyPoint: ''
      },
      group: {
        groupSelected: '',
        groupOption: []
      },
      initButton: true,
      resetButton: false,
      chatName: '',
      nextStrategyId: '',
      labelByRobotReq: {
        message: '',
        strategyId: '',
        time: ''
      },
      responseMessageReq: {
        message: '',
        strategyId: '',
        companyId: '',
        groupId: '',
        time: ''
      },
      corpusInfo: '',
      nextStrategyReq: {
        time: '',
        companyId: '',
        groupId: ''
      },
      contactStatusType: {
        benrendianhua: 'benrendianhuaContactStatus',
        zhixidianhua: 'zhixidianhuaContactStatus'
      },
      sceneOption: [],
      sceneSelected: null,
      initSimulateSceneReq: {
        companyId: '',
        groupId: '',
        sceneId: ''
      },
      conversationId: null
    };
  },
  watch: {
    chatList() {
      this.$nextTick(() => {
        const div = this.$refs.chat_content;
        div.scrollTop = div.scrollHeight;
      });
    }
  },
  mounted() {
    this.getCompanyOptionList();
    this.getSimulateInfo();
  },
  methods: {
    // 公司列表
    getCompanyOptionList() {
      this.$ajax({
        url: '/company/getCompanyListJudgeRole',
        method: 'get'
      }).then((res) => {
        this.company.companyOption = res.data;
        this.company.companySelected = this.$account().companyId;
        res.data.forEach((element) => {
          if (element.id === this.company.companySelected) {
            this.company.strategyPoint = element.strategyPoint;
            return false;
          }
          return true;
        });
        this.companyChange();
      });
    },
    companyChange() {
      // 查对应的策略组
      this.groupReq.companyId = this.company.companySelected;
      this.getGroupOptionList(this.groupReq);
    },
    groupChange() {
      this.getSceneList();
    },
    getGroupOptionList(dataReq) {
      this.$ajax({
        url: '/strategy/selectAllGroupsByCompanyId',
        method: 'POST',
        data: dataReq
      }).then((res) => {
        this.group.groupOption = res.data;
        for (let i = 0; i < res.data.length; i++) {
          const isMain = res.data[i].isMain;
          if (isMain === 1) {
            this.group.groupSelected = res.data[i].id;
          }
        }
        this.getSceneList();
      });
    },
    updateSimulateStatus() {
      this.$ajax({
        url: '/simulate/updateStatus',
        data: this.simulateStatusUpdateReq,
        prompt: true
      }).then();
    },
    initSimulate(button) {
      this.initSimulateSceneReq.companyId = this.company.companySelected;
      this.initSimulateSceneReq.groupId = this.group.groupSelected;
      this.initSimulateSceneReq.sceneId = this.sceneSelected;
      this.conversationId = null;
      this.$ajax({
        url: '/simulate/initSimulateScene',
        data: this.initSimulateSceneReq,
        prompt: true
      }).then((res) => {
        this.chatList = res.data.chatRecordList;
        this.conversationId = res.data.conversationId;
        if (button === 'initSession') {
          this.initButton = false;
          this.resetButton = true;
        }
      });
    },
    sendMsg() {
      this.labelByRobotReq.message = this.selectTemplate.finalTemplate;
      this.labelByRobotReq.time = moment(Date.now()).format('YYYY-MM-DD HH:mm:ss');
      this.labelByRobotReq.strategyId = this.nextStrategyId;
      this.labelByRobotReq.compamyId = this.company.companySelected;
      this.$ajax({
        url: '/simulate/getLabelByRobot',
        data: this.labelByRobotReq
      }).then((res) => {
        this.corpusInfo = res.data.corpusInfoResp;
        const chatRecord = res.data.chatRecordDTO;
        if (chatRecord.time === null || chatRecord.time === '') {
          chatRecord.time = moment(Date.now()).format('YYYY-MM-DD HH:mm:ss');
        }
        this.responseMessage(res.data.corpusInfoResp, chatRecord.time);
        chatRecord.sentiment = res.data.sentiment;
        this.field = res.data.sentiment;
        chatRecord.field = this.field;
        chatRecord.emoji = this.emojiMap[this.field] || '❓';
        this.chatList.push(chatRecord);
        this.selectTemplate.finalTemplate = null;
      });
    },
    responseMessage(corpusInfoResp, time) {
      this.responseMessageReq.corpusInfoResp = corpusInfoResp;
      this.responseMessageReq.time = time;
      this.responseMessageReq.strategyId = this.nextStrategyId;
      this.responseMessageReq.companyId = this.company.companySelected;
      this.responseMessageReq.groupId = this.group.groupSelected;
      this.responseMessageReq.sceneId = this.sceneSelected;
      this.responseMessageReq.conversationId = this.conversationId;
      this.$ajax({
        url: '/simulate/responseMessageScene',
        data: this.responseMessageReq,
        prompt: true
      }).then((res) => {
        const chatRecord = res.data.chatRecordDTO;
        this.chatList.push(chatRecord);
      });
    },
    nextStrategy() {
      if (this.corpusInfo.promiseTime !== '暂无' && this.corpusInfo.label === '有还款意向及时间') {
        this.nextStrategyReq.time = this.corpusInfo.promiseTime;
      } else {
        this.nextStrategyReq.time = moment(Date.now()).format('YYYY-MM-DD HH:mm:ss');
      }
      this.nextStrategyReq.companyId = this.company.companySelected;
      this.nextStrategyReq.groupId = this.group.groupSelected;
      this.$ajax({
        url: '/simulate/nextStrategy',
        data: this.nextStrategyReq
      }).then((res) => {
        const data = res.data;
        this.nextStrategyId = data.strategyId;
        const chatRecord = data.chatRecordDTO;
        if (chatRecord.time === null || chatRecord.time === '') {
          chatRecord.time = moment(Date.now()).format('YYYY-MM-DD HH:mm:ss');
        }
        this.chatList.push(chatRecord);
      });
    },
    generator(name, index) {
      return `${name}${index}`;
    },
    getSimulateInfo() {
      this.$ajax({
        url: '/simulate/gotoRobotSimulate',
        method: 'get'
      }).then();
    },
    getSceneList() {
      this.sceneSelected = null;
      this.$ajax({
        url: '/scene/getSceneParam',
        method: 'POST',
        data: { groupId: this.group.groupSelected, type: 'svoice' }
      }).then((res) => {
        this.sceneOption = res.data;
      });
    }
  }
};
</script>
<style lang="less" scoped>
  @import '../../../assets/style/variable.less';

  .case-detail__header {
    padding: 15px 24px;
    border-bottom: @border;
    .title {
      margin-bottom: 16px;
      .icon {
        margin-right: 12px;
        border-radius: 3px;
        vertical-align: middle;
      }
      .name {
        font-size: 20px;
        vertical-align: middle;
        color: rgba(0, 0, 0, .85);
      }
    }
    .info {
      padding-left: 40px;
      .score {
        line-height: 1;
        font-size: 30px;
        color: #d2a320;
      }
    }
  }
  .case-detail__content {
    .chat-wrapper {
      width: 800px;
      margin: 20px auto;
      border: @border;
      .chat-header {
        padding: 10px;
        background: #eee;
      }
      .chat-content {
        height: 350px;
        .align-left {
          display: flex;
          justify-content: flex-start;
          .content {
            padding-left: 15px;
            &>div {
              background: #f7f7f7;
            }
          }
        }
        .align-right {
          display: flex;
          justify-content: flex-end;
          .content {
            padding-right: 15px;
            &>div {
              color: #fff;
              background: @primary;
            }
          }
        }
        .item {
          padding: 8px;
          max-width: 550px;
          .label {
            padding-top: 8px;
            .avatar {
              width: 30px;
              height: 30px;
              border-radius: 50%;
            }
          }
          .content {
            .time {
              margin: 5px 0;
              display: flex;
              justify-content: space-between;
              font-size: .86rem;
              font-style: italic;
              &>span:last-child {
                margin-left: 20px;
              }
            }
          }
        }
        .content > div {
          padding: 5px;
          background: #fff;
          border-radius: 5px;
        }
      }
      .chat-footer {
        border-top: @border;
        padding: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/main/test_engine/scene_info.vue